module.exports = __webpack_public_path__ + "static/media/ibd_hips1.58eb466e.png";